﻿import { Vue, vuetify, MOUNT_APP, PageMixin } from '../Modules/page-mixin'
import FormMixin from '../Modules/form-mixin'

new Vue({
    vuetify,
    mixins: [PageMixin, FormMixin],
    data: () => ({
        showPassword: false,
        status: ''
    }),
    computed: {
        typeInputPassword () {
            return this.showPassword ? 'text' : 'password'
        },
        iconInputPassword () {
            return this.showPassword ? 'mdi-eye' : 'mdi-eye-off'
        }
    },
    methods: {
        togglePasswordVisibility () {
            this.showPassword = !this.showPassword
        },
        async postLogin () {
            this.status = 'Entrando en el sistema, por favor espere...'
            await this.post()
            
            if (this.isPostOk) {
                this.redirect()
                return
            }
            
            this.status = ''
        },
        redirect () {
            this.status = 'Redirigiendo...'
            document.location.href = this.messages.ok
        }
    }
}).$mount(MOUNT_APP)